/* eslint-disable no-multi-assign */
import { fabric } from 'fabric';

export const getVLinePatternBrush = (canvas, drawingObj = null) => {
  const vLinePatternBrush = new fabric.PatternBrush(canvas);
  vLinePatternBrush.getPatternSrc = () => {
    const patternCanvas = fabric.document.createElement('canvas');
    patternCanvas.width = patternCanvas.height = 10;
    const ctx = patternCanvas.getContext('2d');

    ctx.strokeStyle = drawingObj && drawingObj.lineColor ? drawingObj.lineColor : 'black';
    ctx.lineWidth = 5;
    ctx.beginPath();
    ctx.moveTo(0, 5);
    ctx.lineTo(10, 5);
    ctx.closePath();
    ctx.stroke();

    return patternCanvas;
  };
  return vLinePatternBrush;
};

export const getHLinePatternBrush = (canvas, drawingObj = null) => {
  const hLinePatternBrush = new fabric.PatternBrush(canvas);
  hLinePatternBrush.getPatternSrc = () => {
    const patternCanvas = fabric.document.createElement('canvas');
    patternCanvas.width = patternCanvas.height = 10;
    const ctx = patternCanvas.getContext('2d');

    ctx.strokeStyle = drawingObj && drawingObj.lineColor ? drawingObj.lineColor : 'black';
    ctx.lineWidth = 5;
    ctx.beginPath();
    ctx.moveTo(5, 0);
    ctx.lineTo(5, 10);
    ctx.closePath();
    ctx.stroke();

    return patternCanvas;
  };
  return hLinePatternBrush;
};

export const getSquarePatternBrush = (canvas, drawingObj = null) => {
  const squarePatternBrush = new fabric.PatternBrush(canvas);
  squarePatternBrush.getPatternSrc = () => {
    const squareWidth = 10;
    const squareDistance = 2;

    const patternCanvas = fabric.document.createElement('canvas');
    patternCanvas.width = patternCanvas.height = squareWidth + squareDistance;
    const ctx = patternCanvas.getContext('2d');

    ctx.fillStyle = drawingObj && drawingObj.lineColor ? drawingObj.lineColor : 'black';
    ctx.fillRect(0, 0, squareWidth, squareWidth);

    return patternCanvas;
  };
  return squarePatternBrush;
};

export const getDiamondPatternBrush = (canvas, drawingObj = null) => {
  const diamondPatternBrush = new fabric.PatternBrush(canvas);
  diamondPatternBrush.getPatternSrc = () => {
    const squareWidth = 10;
    const squareDistance = 5;
    const patternCanvas = fabric.document.createElement('canvas');
    const rect = new fabric.Rect({
      width: squareWidth,
      height: squareWidth,
      angle: 45,
      fill: drawingObj && drawingObj.lineColor ? drawingObj.lineColor : 'black',
    });

    const canvasWidth = rect.getBoundingRect().width;

    patternCanvas.width = patternCanvas.height = canvasWidth + squareDistance;
    rect.set({ left: canvasWidth / 2, top: canvasWidth / 2 });

    const ctx = patternCanvas.getContext('2d');
    rect.render(ctx);

    return patternCanvas;
  };
  return diamondPatternBrush;
};

export const getPatternBrush = (canvas, drawingObj = null) => {
  let brushPattern;
  if (drawingObj) {
    switch (drawingObj.mode) {
      case 'vline':
        brushPattern = getVLinePatternBrush(canvas, drawingObj);
        break;
      case 'hline':
        brushPattern = getHLinePatternBrush(canvas, drawingObj);
        break;
      case 'square':
        brushPattern = getSquarePatternBrush(canvas, drawingObj);
        break;
      case 'diamond':
        brushPattern = getDiamondPatternBrush(canvas, drawingObj);
        break;
      default:
        brushPattern = new fabric[`${drawingObj.mode}Brush`](canvas);
        break;
    }
  } else {
    brushPattern = new fabric.PencilBrush(canvas);
  }
  return brushPattern;
};

export const applyBrushToCanvas = (currentBrush, drawingObj = null) => {
  if (currentBrush) {
    const brush = currentBrush;
    brush.color = drawingObj && drawingObj.lineColor ? drawingObj.lineColor : 'black';
    if (brush.getPatternSrc) {
      brush.source = brush.getPatternSrc.call(brush);
    }
    brush.width = drawingObj && drawingObj.lineWidth ? drawingObj.lineWidth : 1;
    if (brush.shadow) {
      brush.shadow.offsetX = drawingObj && drawingObj.shadowOffset ? drawingObj.shadowOffset : 0;
      brush.shadow.offsetY = drawingObj && drawingObj.shadowOffset ? drawingObj.shadowOffset : 0;
      brush.shadow.color = drawingObj && drawingObj.shadowColor ? drawingObj.shadowColor : undefined;
      brush.shadow.blur = drawingObj && drawingObj.shadowColor ? drawingObj.shadowWidth : undefined;
    } else {
      brush.shadow = new fabric.Shadow({
        offsetX: drawingObj && drawingObj.shadowOffset ? drawingObj.shadowOffset : 0,
        offsetY: drawingObj && drawingObj.shadowOffset ? drawingObj.shadowOffset : 0,
        affectStroke: true,
        ...(drawingObj && drawingObj.shadowColor ? { color: drawingObj.shadowColor } : {}),
        ...(drawingObj && drawingObj.shadowWidth ? { blur: drawingObj.shadowWidth } : {}),
      });
    }
  }
};
